import './SkeletonLoader.css';

const SkeletonLoader = () => {
    return (
        <div className="skeleton-loader"></div>
    );
};

export default SkeletonLoader;
